import React, { useEffect, useState } from 'react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Add shadow and slightly different background when scrolled
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Clean up event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <header className={`w-full bg-amber-50 py-4 border-b fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${isScrolled ? 'border-amber-200 shadow-sm bg-amber-50/95 backdrop-blur-sm' : 'border-amber-100'}`} data-id="element-140">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-141">
        <div className="text-center" data-id="element-142">
          <h1 className="text-2xl font-serif font-bold text-amber-800" data-id="element-143">
            MétodoMilhojasPerfecta
          </h1>
          <p className="text-sm text-amber-700" data-id="element-144">by Stella Pereira</p>
        </div>
      </div>
    </header>;
}